/* eslint-disable max-lines-per-function */
import { useRouter } from 'next/router'
import classNames from 'classnames'
import React, { useState } from 'react'
// import dynamic from 'next/dynamic'
import { useQuery } from 'react-query'
import {
  loggedInNavLinks,
  loggedInNavLinksWithFnO,
} from './utils/navigation-items'
import Link from '@/components/Common/Link'
// import AppOnlyFeature from '@/stories/components/AppOnlyFeatureModal'
import { DASHBOARD_HEADER_NAV_CLICK } from '@/root/utils/common/web/gtm-events/eventsList'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
// import { InView } from 'react-intersection-observer'
import { fetchRequest } from '@/root/utils/network-adapter/fetch-request'
import { vyaparBOApiBaseUrl } from '@/root/api/apiConstants'
import { TUserDetailsDemat } from '@/stencil/investments/stocks/my-ind-stocks'
import useGetAuthToken from '@/hooks/use-get-auth-token'
import Cookies from 'js-cookie'

function getSelectedNonSelectedClassNames(
  pathname: string = '',
  type: (typeof loggedInNavLinks)[number]['type'],
) {
  return classNames({
    'text-brand-blue-azureRadiance border-brand-blue-azureRadiance border-1':
      pathname.includes(type),
    'text-brand-blue-cornFlower': !pathname.includes(type),
  })
}

// NOTE: Now this Desktop Navigation Component in only used for Authenticated state

export default function HeaderNavigation({ host }: { host?: string }) {
  const router = useRouter()
  const { pathname } = router

  const pushEvent = useAnalyticsEvent()

  const [navlinks, setNavlinks] = useState(loggedInNavLinks)

  const token = useGetAuthToken()

  const member_id = Cookies.get('memberId')

  useQuery<TUserDetailsDemat>(
    'fno-onboarding-status',
    () => {
      return fetchRequest({
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
            Platform: 'web',
          },
        },
        timeout: 0,
        url: `${vyaparBOApiBaseUrl}/onboard/status?segment=equity_derivative${
          member_id ? `&member_id=${member_id}` : ''
        }`,
      })
    },
    {
      onSuccess(data) {
        if (data.is_onboarded === true) {
          setNavlinks(loggedInNavLinksWithFnO)
        }
      },
      enabled: !!token,
    },
  )

  const loggedInJSX = (
    <div>
      <ul className="m-0 flex space-x-2">
        {navlinks.map(({ link, text, nativeAnchor, type, dontShowOn }, idx) => {
          const hostMatchingObjectToNotShow = dontShowOn?.find(
            el => el.host === host,
          )

          if (hostMatchingObjectToNotShow?.host === host) {
            return null
          }
          const linkProps: {
            onClick?: (
              e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
            ) => void
          } = {}

          return (
            <Link
              onClick={() =>
                pushEvent({
                  mixpanelEventPayload: {
                    eventName: DASHBOARD_HEADER_NAV_CLICK,
                    payload: {
                      cta_name: text,
                    },
                  },
                })
              }
              key={link}
              href={link}
              nativeAnchor={nativeAnchor}
              className={`flex flex-col items-center ${
                idx === navlinks.length - 1 ? 'hidden xl:block' : ''
              }`}
              title={text}
              {...linkProps}
            >
              <div
                className={classNames(
                  'text-16px bg-brand-tertiary-grey hover:text-brand-blue-azureRadiance rounded-xl px-[12px] py-1',
                  getSelectedNonSelectedClassNames(pathname, type),
                  // { 'text-brand-blue-cornFlower border-0': isOpenMoreOverlay },
                )}
              >
                {text}
              </div>

              {/* <AppOnlyFeature
                onClose={() => {
                  setRewardsModalState('closed')
                }}
                showModal={rewardsModalState === 'open'}
              /> */}
            </Link>
          )
        })}
      </ul>
    </div>
  )

  return <nav className="h-full">{loggedInJSX}</nav>
}
